import { format, isValid } from "date-fns";
import Image from "next/image";
import Link from "next/link";

import { Title } from "@/features/common/components/Title";
import { getPublicConfig } from "@/helpers/getPublicConfig";

import { getBlogLink } from "../helpers/getBlogLink";
import { BlogPost } from "../type";

const { features } = getPublicConfig();

type BlogItemProps = {
  blogPost: BlogPost;
};

export function BlogItem({ blogPost }: BlogItemProps) {
  const { title, description, coverImageUrl, displayDate } = blogPost;
  const href = getBlogLink(blogPost);

  const date = new Date(displayDate);

  return (
    <div className="py-8 lg:mx-0 lg:grid lg:grid-cols-3 lg:gap-8">
      {coverImageUrl && (
        <Link href={href}>
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            className="aspect-[3/2] object-cover"
            alt={title}
            width={900}
            height={600}
            src={coverImageUrl}
          />
        </Link>
      )}

      <div className="mt-4 lg:col-span-2 lg:mt-0">
        <Link href={href}>
          <Title
            size="h4"
            className="text-xl font-medium text-gray-900 hover:opacity-70"
          >
            {title}
          </Title>
        </Link>

        <div className="py-2 text-sm text-gray-400">
          KOL Jobs |{" "}
          {isValid(date) ? format(date, features.common.dateFormat) : ""}
        </div>

        <p className="text-gray-500">{description}</p>
      </div>
    </div>
  );
}
